var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecondIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.75,
    height: 25.75,
    viewBox: "0 0 25.75 25.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2522",
    "data-name": "Group 2522",
    transform: "translate(-282 -350)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noun-first-5181176",
    d: "M141.856,58.976V53.639H136.52l-3.77-3.77-3.77,3.77h-5.336v5.336l-3.77,3.77,3.77,3.77v1.43H125.6V65.7l-2.967-2.957,2.967-2.957V55.6h4.19l2.957-2.967,2.957,2.967h4.19v4.19l2.967,2.957L139.9,65.7v4.19h-4.19l-2.957,2.967-2.957-2.967h-6.149v1.958h5.336l3.77,3.77,3.77-3.77h5.336V66.515l3.77-3.77Z",
    transform: "translate(162.125 300.13)",
    fill: "#68d808"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": 2,
    transform: "translate(291 366)",
    fill: "#68d808",
    fontSize: 13,
    fontFamily: "MyanmarMN-Bold, Myanmar MN",
    fontWeight: 700,
    letterSpacing: "0.005em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondIcon);
export default __webpack_public_path__ + "static/media/second_icon.e9fbdd8155f5e2378b2b167e27b9d9d5.svg";
export { ForwardRef as ReactComponent };